import useFetchOnce, { fetchOnce, isFetchPossible, isFetchRequired } from './useFetchOnce';
import * as loadState from './useLoadState';

const { useLoadState, useLoadStates, useLoadSetupStates } = loadState;

export {
  loadState,
  useLoadState,
  useLoadStates,
  useLoadSetupStates,
  fetchOnce,
  useFetchOnce,
  isFetchPossible,
  isFetchRequired,
};
